module.exports = __webpack_public_path__ + "img/AUD.9b190203.png";